function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Wrapper } from '../card';
import * as SCALE from '../../theme/scale';
const ImgCardWrapper = styled(Wrapper)`
  flex-direction: ${({
  direction
}) => direction};
  height: ${({
  height
}) => height};
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  ${({
  padding
}) => padding && `padding: ${SCALE[padding]};`}
  ${({
  direction
}) => direction === 'row' || direction === 'row-reverse' ? `width: 100%;` : `height: 100%;`}
`;
export const ImageCard = /*#__PURE__*/forwardRef(({
  img,
  direction,
  width,
  height,
  elevation,
  outline,
  padding = 'size12',
  children,
  altText = 'activity-icon',
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(ImgCardWrapper, _extends({
    ref: ref,
    direction,
    width,
    elevation,
    outline,
    height,
    altText
  }, props), /*#__PURE__*/React.createElement("img", {
    alt: altText,
    src: img
  }), /*#__PURE__*/React.createElement(Content, {
    padding,
    direction
  }, children));
});
export default ImageCard;
//# sourceMappingURL=index.js.map